export class PostPaymentSuccessError extends Error {
  constructor(message) {
    super(message);
    this.name = 'POST_PAYMENT_SUCCESS_ERROR';
  }
}
